import {useAppDispatch, useAppSelector} from "../../reducers/hooks";
import React, {MouseEvent, useEffect, useMemo, useState} from "react";
import {ColumnDef, ColumnFiltersState} from "@tanstack/react-table";
import type {TenantElement} from "../../reducers/Tenant/TenantReducer"; // Adjust the path as necessary
import {deleteElement, getAllElement} from "../../reducers/Tenant/TenantReducer";
import Stack from "@mui/material/Stack";
import {Typography} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {Edit, Trash} from "iconsax-react";
import Grid from "@mui/material/Grid";
import BasicTable from "../../components/tables/BasicTable";
import ElementModalGeneric from "../../sections/modals/exampleElementModal/ElementModalGeneric";
import AlertExampleElementDelete from "../../sections/modals/exampleElementModal/AlertExampleElementDelete";
import TenantElementForm from "../../sections/forms/Tenant/TenantElementForm";
import {FormattedMessage, useIntl} from "react-intl";

export default function Tenant() {
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const [open, setOpen] = useState<boolean>(false);
    const data = useAppSelector(state => state.tenantElement.elements);
    const [selectedElement, setSelectedElement] = useState<TenantElement | null>(null);
    const [selectedDeleteElement, setSelectedDeleteElement] = useState<any>();
    const [deleteAlertOpen, setDeleteAlertOpen] = useState<boolean>(false);

    const [searchTerms, setSearchTerms] = useState({
        businessName: "",
        city: "",
        Enabled: "",

    });

    // Funzione per gestire la modifica dei campi di ricerca
    const handleSearchChange = (key: string, value: string) => {
        setSearchTerms(prev => ({
            ...prev,
            [key]: value,
        }));
    };


    const columns = useMemo<ColumnDef<TenantElement>[]>(
        () => [

            {
                header: intl.formatMessage({id: "businessName"}),
                accessorKey: 'businessName',
            },
            {
                header: intl.formatMessage({id: "city"}),
                accessorKey: 'city',
            },
            {
                header: intl.formatMessage({id: "Enabled"}),
                accessorKey: 'isActive',
                enableColumnFilter: false,
                disableSortBy: true,
                cell: ({row}) => {
                    return (
                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={0}>
                            <Typography>
                                {row.original.isActive ? "Attivo" : "Disattivo"}
                            </Typography>
                        </Stack>
                    )
                }
            },

            {
                header: () => <FormattedMessage id="Actions" defaultMessage="Actions"/>,
                enableColumnFilter: false,
                accessorKey: 'Actions',
                meta: {
                    className: 'cell-right'
                },
                disableSortBy: true,
                cell: ({row}) => {
                    return (
                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={0}>
                            <Tooltip title={<FormattedMessage id="edit" defaultMessage="edit"/>}>
                                <IconButton
                                    color="primary"
                                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                        e.stopPropagation();
                                        setSelectedElement(row.original); // Setta l'elemento da editare
                                        setOpen(true);                    // Mostra la modale di edit
                                    }}
                                >
                                    <Edit/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={<FormattedMessage id="Delete" defaultMessage="Delete"/>}>
                                <IconButton
                                    color="error"
                                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                        e.stopPropagation();
                                        setSelectedDeleteElement(row.original); // Setta l'elemento da eliminare
                                        setDeleteAlertOpen(true);               // Mostra la modale di delete
                                    }}
                                >
                                    <Trash/>
                                </IconButton>
                            </Tooltip>

                        </Stack>
                    );
                }
            }
        ],
        []
    );
    useEffect(() => {
        dispatch(getAllElement())
    }, []);

    const handleModalOpen = (open: boolean) => {
        setOpen(open)
        setSelectedElement(null)
    }
    const handleDelete = (_id: string) => {
        dispatch(deleteElement(_id))
    };

    const {formatMessage} = useIntl();
    const getTableTitle = () => {
        return formatMessage({id: "TenantTitle", defaultMessage: "Tenant"});
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <BasicTable columns={columns}
                            data={data} title={getTableTitle()} striped
                            modalToggler={() => handleModalOpen(!open)}
                            onFilterChange={(values: ColumnFiltersState) => console.log(values)}
                            manualFiltering={false}/>
                <ElementModalGeneric
                    open={open}
                    setOpen={handleModalOpen}
                    element={selectedElement}
                    FormComponent={TenantElementForm}
                />
                {selectedDeleteElement &&
                    <AlertExampleElementDelete id={selectedDeleteElement._id} title={selectedDeleteElement.businessName}
                                               open={deleteAlertOpen} handleClose={() => setDeleteAlertOpen(false)}
                                               onDelete={(_id) => handleDelete(_id)}/>}
            </Grid>
        </Grid>
    )
}